<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbitembrand_brandTitle"
        class="form-control-label">{{$t('views.exsbitembrand.form.title')}}:</label>
      <input
        id="exsbitembrand_brandTitle"
        v-model="item.brandTitle"
        :class="['form-control', isInvalid('brandTitle') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('brandTitle', $event.target.value)">
      <div
        v-if="isInvalid('brandTitle')"
        class="invalid-feedback">{{ violations.brandTitle }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
